import { useCallback } from 'react';

import { LoyaltyOffer } from 'state/loyalty/types';

import { useServiceOffers } from '../state/service-offers-context';

import { useEnableLoyaltyServiceOffers } from './use-enable-loyalty-service-offers';

/**
 * Optimistically retain a just-applied offer in the provider so the applied-offer
 * seams resolve it before the applied-offers batch settles. No-op when the
 * loyalty-service gate is off.
 */
export function useRetainAppliedOffer() {
  const { enabled } = useEnableLoyaltyServiceOffers();
  const { appliedOffersBatch } = useServiceOffers();
  const { retainAppliedOffer } = appliedOffersBatch;

  return useCallback(
    (offer: LoyaltyOffer) => {
      if (enabled) {
        retainAppliedOffer(offer);
      }
    },
    [enabled, retainAppliedOffer]
  );
}
